export type AirshowReviewTool = "compare" | "junction" | "heartbeat";

interface AirshowReviewToolNavigationProps {
  selected: AirshowReviewTool;
  junctionDisabled: boolean;
  heartbeatDisabled: boolean;
  onSelect: (tool: AirshowReviewTool) => void;
}

export function AirshowReviewToolNavigation({
  selected, junctionDisabled, heartbeatDisabled, onSelect,
}: AirshowReviewToolNavigationProps) {
  return <nav aria-label="Airshow review tools" className="airshow-review-tools" role="tablist">
    <button aria-selected={selected === "compare"} data-testid="openvsp-tool-compare" onClick={() => onSelect("compare")} role="tab" type="button">Airshow Compare</button>
    <button aria-selected={selected === "junction"} data-testid="openvsp-tool-junction" disabled={junctionDisabled} onClick={() => onSelect("junction")} role="tab" type="button">Diagnostic junction preview</button>
    <button aria-selected={selected === "heartbeat"} data-testid="openvsp-tool-heartbeat" disabled={heartbeatDisabled} onClick={() => onSelect("heartbeat")} role="tab" type="button">Fleet heartbeat</button>
  </nav>;
}
